import {
  TComponentValue,
} from '@/types/openapi-type.ts';

type TNextState = Exclude<TComponentValue<'MaintenanceState'>, 'PENDING' | 'REJECTED'>;
type TPrevState = Exclude<TComponentValue<'MaintenanceState'>, 'COMPLETED' | 'IN_REVIEW'>;
type TStageChangeButtons = {
  next: Record<TNextState, string>,
  previous: Record<TPrevState, string>,
};

const stateChangeButtons: TStageChangeButtons = {
  next: {
    // PENDING -> ASSIGNED
    ASSIGNED: 'Akceptuj pracę',
    // ASSIGNED -> IN_PROGRESS
    IN_PROGRESS: 'Rozpocznij pracę',
    // IN_PROGRESS -> IN_REVIEW
    IN_REVIEW: 'Zakończyć pracę',
    // IN_REVIEW -> COMPLETED
    COMPLETED: 'Zatwierdź pracę',
  },
  previous: {
    // ASSIGNED -> PENDING
    PENDING: 'Odrzuć pracę',
    // IN_PROGRESS -> ASSIGNED
    ASSIGNED: 'Przerwij pracę',
    // IN_REVIEW -> IN_PROGRESS
    IN_PROGRESS: 'Odrzuć pracę',
    // IN_REVIEW -> REJECTED
    REJECTED: 'Odrzuć pracę',
  },
};

export default {
  stateChangeButtons,
};
